import dayjs from "dayjs"

export const ADULT_AGE = 18
export default (value: string | null) => {
  const date = dayjs(value, "DD/MM/YYYY", true)
  if (!date.isValid() || !date.isBefore(dayjs().subtract(ADULT_AGE, "years"))) {
    return "Please enter a valid date of birth"
  }

  return true
}
